import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SessionService } from '../services/session.service';
import { StartService } from '../services/start.service';
import { environment } from 'src/environments/environment';
import { UserNotificationStateService } from '@core/services/notifications/user-notification-state.service';

export const authGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const startService = inject(StartService);
  const userNotificationStateService = inject(UserNotificationStateService);

  if (sessionService.get() || sessionService.sessionToken) {
    return true;
  }

  return startService.prepareCompaniesAndUsers().pipe(
    map(() => true),
    catchError(() => {
      redirectToPlatform(userNotificationStateService);
      return of(false);
    })
  );
};

function redirectToPlatform(
  userNotificationStateService: UserNotificationStateService
): void {
  let url = `${environment.externalUrls.platform}`;
  if (userNotificationStateService.isIOS) {
    url += `/login?fromLivechatV2=${encodeURIComponent(true)}`;
  }
  window.open(url, '_self');
}
